import * as React from 'react';
import { Step, Stepper, StepLabel } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { StepItem } from '../types/steps';

const useStyles = makeStyles(theme =>
  createStyles({
    stepperRoot: {
      backgroundColor: 'initial',
      marginBottom: theme.spacing(5),
      padding: theme.spacing(4, 5),
      [theme.breakpoints.down('md')]: {
        position: 'relative',
        marginBottom: theme.spacing(7.5),
        padding: theme.spacing(0, 2)
      }
    },
    step: {
      position: 'relative',
      [theme.breakpoints.down('md')]: {
        position: 'static'
      }
    },
    iconContainer: {
      paddingRight: 0
    },
    labelContainer: {
      position: 'absolute',
      top: 34,
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      [theme.breakpoints.down('md')]: {
        top: 49,
        paddingLeft: theme.spacing(3),
        right: 'initial',
        justifyContent: 'flex-start',
        boxSizing: 'border-box'
      }
    },
    stepLabel: {
      flexShrink: 0,
      fontWeight: 600,
      letterSpacing: '0.00625em',
      [theme.breakpoints.down('md')]: {
        display: 'none',
        fontSize: 16
      },
      '&.MuiStepLabel-active': {
        fontWeight: 600,
        [theme.breakpoints.down('md')]: {
          display: 'inline'
        }
      }
    }
  })
);

type Props = {
  steps: StepItem[];
  onChange?: (step: number, activeStep: number) => void;
};
export const Steps: React.FC<Props> = ({ steps, onChange }) => {
  const classes = useStyles();
  const activeStep = steps.findIndex(step => step.active);

  const handleChange = (step: number, activeStep: number) => () => {
    onChange && onChange(step, activeStep);
  };

  return (
    <Stepper
      nonLinear
      classes={{
        root: classes.stepperRoot
      }}
    >
      {steps.map((step, index) => {
        const { title, hidden, wasShown } = step;
        let active = activeStep === index;

        if (steps[index + 1] && steps[index + 1].hidden && steps[activeStep].hidden) {
          active = true;
        }

        if (hidden) return null;

        return (
          <Step
            active={active}
            key={title}
            completed={wasShown && index < activeStep && !active}
            classes={{ root: classes.step }}
          >
            <StepLabel
              onClick={handleChange(index, activeStep)}
              classes={{
                label: classes.stepLabel,
                iconContainer: classes.iconContainer,
                labelContainer: classes.labelContainer
              }}
            >
              {title}
            </StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );
};
